/**
 * Component: Percentage calculation
 * ------------------------------------------------------------------------------
 * Re-calculates Liquid percentage off.
 *
 * @namespace percentageCalculation
 */
import {percentageSaving} from '../helpers/utils'
import log from 'salvo-lite/log'

class PercentageCalculation {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            dataPercentage: '[data-percentage="container"]'
        }
        this._instances = JSON.parse(elem.getAttribute('data-percentage-calculation') || '{}')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        this._setEventListeners()
        this._checkElements()
    }

    /**
     * Set event listeners.
     */
    _setEventListeners () {
        window.Frame.EventBus.listen('RelatedCarousel:loaded', () => this._checkElements())
    }

    /**
     * Check through all percentage off elements.
     */
    _checkElements () {
        const dataElements = [...document.querySelectorAll(this._settings.dataPercentage)]

        this._calculatePercentage(this._elem)

        /**
         * Directed Edge removes js- attributes.
         */
        dataElements.forEach((element) => {
            this._calculatePercentage(element)
        })
    }

    /**
     * Calculates the percentage off based on price and compare at price.
     * @param {HTMLElement} element – The percentage off element.
     */
    _calculatePercentage (element) {
        if (element.getAttribute('data-calculated') === 'true') {
            return
        }

        const price = element.getAttribute('data-price')
        const compareAtPrice = element.getAttribute('data-compare-at-price')

        if (element.textContent.includes('{discount}')) {
            element.textContent = element.textContent.replace('{discount}', `${percentageSaving(price, compareAtPrice)}%`)
        } else {
            element.innerText = percentageSaving(price, compareAtPrice)
        }

        element.setAttribute('data-calculated', true)
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // })
}

export default PercentageCalculation



// WEBPACK FOOTER //
// ./src/resources/scripts/components/PercentageCalculation.js